var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vue-content-loading",
    {
      attrs: {
        height: 15,
        width: 580,
        speed: 2,
        "primary-color": "#f3f3f3",
        "secondary-color": "#ecebeb",
      },
    },
    [
      _c("rect", {
        attrs: {
          stroke: "#000",
          height: "15",
          width: "75",
          y: "0",
          x: "420.5",
        },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          stroke: "#000",
          height: "15",
          width: "75",
          y: "0",
          x: "502.5",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }